import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableNetwork } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// 接続先環境のデバッグログ（必要に応じて削除してください）
if (import.meta.env.DEV) {
  console.log(
    '[Firebase] 環境: development',
    'projectId =',
    import.meta.env.VITE_FIREBASE_PROJECT_ID
  );
} else {
  console.log(
    '[Firebase] 環境: production',
    'projectId =',
    import.meta.env.VITE_FIREBASE_PROJECT_ID
  );
}

const firebaseApp = initializeApp(firebaseConfig);
export const app = firebaseApp;
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const functions = getFunctions(firebaseApp, 'asia-northeast1');

// Firestore接続の最適化
try {
  // ネットワーク接続を有効化
  enableNetwork(db);
} catch (error) {
  console.warn('Firestore ネットワーク接続の設定に失敗しました:', error);
  // エラーが発生した場合は再接続を試行
  try {
    enableNetwork(db);
  } catch (retryError) {
    console.error('Firestore 再接続も失敗しました:', retryError);
  }
}

// エミュレーター接続を無効化（本番Firebaseを使用）
// エミュレーターを使用する場合は、以下のコメントを外してエミュレーターを起動してください
/*
if (import.meta.env.DEV && !auth.emulatorConfig) {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
  } catch (error) {
  }
}
*/
